<template>
    <div class="relatorio-analitico">
        <RelatorioAnaliticoComponentList
            app_modulo="promotor"
            app_submodulo="relatorio-analitico"
            app_tela="relatorio-pro-formulario-resposta"
            :objectList="formularioRespostaList"
            :objectListAll="formularioRespostaListAll"
            :isEmpty="isEmpty"
            :isLoading="isLoading"
            :isDataStarted="isDataStarted"
            :pagination="pagination"
            :tooltipLabelSearch="$t('msg-campo-busca-n', { n: `${$t('grupo')}, ${$t('pergunta')}, ${$t('tipo')}, ${$t('resposta')} ` })"
            showLateralFilter
            :cameFrom="cameFrom"
            @filtersReset="filtersReset = $event"
            @loadedFiels="loadedFiels = $event"
            @carregarDados="carregarDados($event)"
            @carregarDadosExportAll="carregarDados($event, true)"
            @search="onSearch($event)"
            @clearFilter="clearFilter()"
            @orderColumn="pagination.orderColumn = $event"
            @orderDirection="pagination.orderDirection = $event"
            @perPage="pagination.perPage = $event"
            @currentPage="pagination.currentPage = $event"
            @isLoading="isLoading = $event"
            @voltar="$emit('voltar', $event)"
        >
            <template v-slot:top-filter>
                <vss-select
                    title="empresa"
                    ref="empresaSelect"
                    class="smaller"
                    :value="empresaSelected"
                    :options="empresaList"
                    :height="40"
                    :loading="empresaLoading"
                    @search="carregarEmpresas"
                    @input="updateEmpresa"
                    label="rsocial"
                    :closeOnSelect="false"
                    no-clearfix
                    multiple
                    clearable
                    searchable
                >
                    <template #multiple-selected="{ selected }">
                        ({{ selected && selected.length > 0 ? selected.length : $t('todos') }})
                    </template>
                </vss-select>
                <vss-select
                    title="colaborador"
                    ref="colaboradorSelect"
                    class="smaller"
                    :value="colaboradorSelected"
                    :options="colaboradorList"
                    :height="40"
                    :loading="colaboradorLoading"
                    @search="carregarColaboradores"
                    @input="updateColaborador"
                    label="nome"
                    :closeOnSelect="false"
                    no-clearfix
                    multiple
                    clearable
                    searchable
                    tooltipLabel="msg-associacao-empresa-colaborador"
                >
                    <template #multiple-selected="{ selected }">
                        ({{ selected && selected.length > 0 ? selected.length : $t('todos') }})
                    </template>
                </vss-select>
            </template>
            <template v-slot:table-column="{ props, field }">
                <div>
                    {{ isNull(props.row[field.key]) ? '---' : props.row[field.key] }}
                </div>
            </template>
            <template v-slot:lateral-filter>
                <FiltroProFormularioResposta
                    ref="filtroRef"
                    :filtersReset="filtersReset"
                    @update-filtro="updateFiltro"
                />
            </template>
        </RelatorioAnaliticoComponentList>
    </div>
</template>
<script>
import RelatorioAnaliticoComponentList from '@/components/shared/tela/RelatorioAnaliticoComponentList.vue';
import FiltroProFormularioResposta from './RelatorioFormularioRespostaListFiltro.vue';
export default {
    name: 'RelatorioFormularioRespostaList',
    components: {
        RelatorioAnaliticoComponentList,
        FiltroProFormularioResposta,
    },
    props: {
        cameFrom: {
            type: String,
            default: 'route',
        },
        idFrom: {
            type: Number,
            default: 0,
        },
        reloadData: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            formularioRespostaList: [],
            formularioRespostaListAll: [],
            isEmpty: false,
            isLoading: false,
            isDataStarted: false,
            pagination: {
                resetPagination: false,
                perPageOptions: [10, 25, 50, 100],
                optionStarted: 0,
                perPage: null,
                totalRows: 0,
                currentPage: 1,
                orderColumn: 'id',
                orderDirection: 'desc',
                queryFilter: '.*',
            },
            filtersReset: false,
            loadedFiels: false,
            filtros: {
                dataInicial: new Date(this.$moment().subtract(30, 'days')),
                dataFinal: new Date(),
                idEmpresaList: [],
                idColaboradorList: [],
                idClienteList: [],
                idLpsList: [],
                idContratoList: [],
                idFormularioList: [],
            },

            empresaList: [],
            empresaSelected: [],
            empresaLoading: false,

            colaboradorList: [],
            colaboradorSelected: [],
            colaboradorLoading: false,

            contratoSelect: [],
            contratoSelected: [],
            contratoLoading: false,
        };
    },
    watch: {
        reloadData(val) {
            if (val) this.carregarDados(this.pagination.currentPage);
        },
    },
    created() {
        this.pagination.perPage = this.pagination.perPageOptions[this.pagination.optionStarted];
    },
    methods: {
        carregarDados(currentPage = 1, getAll = false) {
            if (!getAll && currentPage == 1 && this.pagination.currentPage != 1) {
                this.pagination.resetPagination = true;
            }

            if (!getAll) this.formularioRespostaListAll = [];

            this.isLoading = true;
            this.$axios
                .post(`pro/relatorio-analitico/formulario-resposta/list.json`, this.filtros, {
                    params: {
                        column: this.pagination.orderColumn,
                        order: this.pagination.orderDirection,
                        page: currentPage - 1,
                        limit: getAll ? this.pagination.totalRows : this.pagination.perPage,
                        search: this.pagination.queryFilter,
                    },
                })
                .then((response) => {
                    if (!getAll) {
                        this.isEmpty = response.data.totalElements == 0;
                        this.pagination.totalRows = response.data.totalElements;
                    }

                    return response.data.content.map((obj) => {
                        return {
                            ...obj,
                            data_hora: this.$moment(obj.data_hora).format('L LT'),
                            atendimento_data: this.$moment(obj.atendimento_data).format('L')
                        };
                    });
                })
                .then((mappedContent) => {
                    if (getAll) {
                        this.formularioRespostaListAll = mappedContent;
                    } else {
                        this.formularioRespostaList = mappedContent;
                    }
                })
                .catch((exception) => {
                    this.isEmpty = true;
                    this.$root.showMessage('error', 'msg-erro-dados-geral');
                })
                .finally((_) => {
                    this.pagination.resetPagination = false;
                    this.isDataStarted = true;
                    if (this.loadedFiels) this.isLoading = false;
                });
        },
        onSearch(query) {
            query = this.isNull(query) ? '' : this.removeToSearch(query);
            this.pagination.queryFilter = query;
            this.carregarDados();
        },
        clearFilter() {
            this.pagination.queryFilter = '.*';
            this.filtros.dataInicial = new Date(this.$moment().subtract(30, 'days'));
            this.filtros.dataFinal = new Date();

            this.filtros.idEmpresaList = [];
            this.empresaSelected = [];

            this.filtros.idColaboradorList = [];
            this.colaboradorSelected = [];

            this.filtros.idClienteList = [];
            this.filtros.idLpsList = [];
            this.filtros.idContratoList = [];
            this.filtros.idFormularioList = [];

            setTimeout(() => {
                this.carregarDados();
            }, 1000);
        },
        updateFiltro(filtro) {
            this.filtros[filtro.nomeFiltro] = filtro.valor;
        },

        carregarEmpresas(query = '') {
            this.empresaLoading = true;

            query = this.isNull(query) ? '' : this.removeToSearch(query);

            this.$axios
                .get(`/vendas/empresa/list.json?param=${query}`)
                .then((response) => {
                    this.empresaList = response.data.content.map((e) => {
                        return {
                            id: e.idempresa,
                            rsocial: e.rsocial,
                        };
                    });
                })
                .catch(() => {
                    this.empresaList = [];
                })
                .finally(() => {
                    this.empresaLoading = false;
                });
        },
        updateEmpresa(empresa) {
            this.empresaSelected = empresa;

            this.colaboradorSelected = [];
            this.colaboradorList = [];

            this.filtros.idEmpresaList =
                this.empresaSelected.length == 0 ? [] : this.empresaSelected.map((e) => e.id);

            this.carregarColaboradores('');
            this.carregarDados();
        },
        carregarColaboradores(query = '') {
            this.colaboradorLoading = true;

            query = this.isNull(query) ? '' : this.removeToSearch(query);

            const empresa =
                this.empresaSelected.length > 0 ? this.empresaSelected.map((e) => e.id) : [];

            this.$axios
                .post(`/employees/list/associacaoidsempresa.json?search=${query}`, empresa)
                .then((response) => {
                    this.colaboradorList = response.data.content;
                })
                .catch(() => {
                    this.empresaList = [];
                })
                .finally(() => {
                    this.colaboradorLoading = false;
                });
        },
        updateColaborador(colaborador) {
            this.colaboradorSelected = colaborador;

            this.filtros.idColaboradorList =
                this.colaboradorSelected.length == 0
                    ? []
                    : this.colaboradorSelected.map((e) => e.id);

            this.carregarDados();
        },
    },
};
</script>
<style lang="scss" scoped>
.relatorio-analitico {
    height: 100%;
}
</style>